module.exports = __webpack_public_path__ + "static/1.e42ee43f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/1.jpg
// module id = 697
// module chunks = 168707334958949